// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-modal-anti-modal-padding-5l7rKm1zmwr{margin:0 -16px}", "",{"version":3,"sources":["webpack://client/shared/modals/variants/search-modal.scss"],"names":[],"mappings":"AAEA,6CACE,cAAA","sourcesContent":["@import \"~@css/vars.scss\";\n\n.anti-modal-padding {\n  margin: 0 -#{$modal-padding-mobile};\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1faece",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#f7e28b",
	"violetLight2": "#cec0ec",
	"tealLight3": "#cfece8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"anti-modal-padding": "search-modal-anti-modal-padding-5l7rKm1zmwr",
	"antiModalPadding": "search-modal-anti-modal-padding-5l7rKm1zmwr"
};
export default ___CSS_LOADER_EXPORT___;
